import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.DealerGroupClaimType.Save.IRequest;
type Response = Api.Core.DealerGroupClaimType.Save.IResponse;
type Headers = Api.Core.DealerGroupClaimType.Save.IHeaders;
const saveApiDealerGroupClaimTypePath = '/api/DealerManagement/DealerGroupClaimType';
export default async function dealerGroupClaimTypeSaveApi(body: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    url: createPathFromRoute(saveApiDealerGroupClaimTypePath, null, null),
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    body: body,
    headers: getDefaultHeaders(),
  });
}
